
export const AI_INTENTS = {
  MEDICAL_EMERGENCY: 'medical_emergency',
  MEDICAL_ROUTINE: 'medical_routine',
  LOST_PET: 'lost_pet',
  FOUND_PET: 'found_pet',
  FIND_SERVICE: 'find_service',
  FIND_PLACE: 'find_place',
  COMMUNITY_QUESTION: 'community_question',
  WEATHER_HAZARD: 'weather_hazard',
  OFF_TOPIC: 'off_topic',
  UNKNOWN: 'unknown',
};

export const AI_URGENCIES = {
  HIGH: 'high',
  MEDIUM: 'medium',
  LOW: 'low',
};

export const AI_UI_STATES = {
  NORMAL: 'NORMAL',
  EMERGENCY: 'EMERGENCY',
  INFO: 'INFO',
};

const KNOWN_INTENTS = new Set(Object.values(AI_INTENTS));

export function assertKnownIntent(intent) {
  if (
    intent != null &&
    !KNOWN_INTENTS.has(intent) &&
    process.env.NODE_ENV !== 'production'
  ) {
    // eslint-disable-next-line no-console
    console.warn(
      `[AISearch] Unknown intent received: ${JSON.stringify(intent)}. ` +
        'Update intentToActions / intentToVideos / deriveUIState.'
    );
  }
}
